import * as ActionTypes from 'state/actions/types'
import Session from 'shared/utils/session'

const initialState = {
  isSidebarMenuExpanded: Session.hasItem('isSidebarMenuExpanded')
    ? Session.getItem('isSidebarMenuExpanded') == 'true'
    : true
}

export default (state = initialState, action) => {
  switch (action.type) {

    case ActionTypes.TOGGLE_EXPAND_MENU: {

      const isSidebarMenuExpanded = !state.isSidebarMenuExpanded

      Session.setItem('isSidebarMenuExpanded', isSidebarMenuExpanded)

      return {
        ...state,
        isSidebarMenuExpanded
      }
    }

    default:
      return state
  }
}
